import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Select, Card, Typography, Row, Col, Form, Input, Radio, Button, Divider, InputNumber, Upload, Checkbox } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { REGIONS, TYPE_OF_HOUSING } from '../../config/constants/DropDownForms';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { SET_PREVIEW_DATA } from '../../state/lease_contract/types';
import PropTypes from 'prop-types';
//import Env from '../../config/environment';

const { Option, OptGroup } = Select;
const { Title, Text, Link } = Typography;
//const env = Env();

const PropertyForm = ({ id, contractFormData, previewData, setPreview, regex }) => {
  const [hasParkingLot, setParkingLot] = useState(contractFormData.parking && contractFormData.parking[0]);
  const [hasWarehouse, setHasWarehouse] = useState(contractFormData.warehouse && contractFormData.warehouse[0]);
  const [typeOfHousing, setTypeOfHousing] = useState(contractFormData.typeOfHousing && contractFormData.typeOfHousing);
  const [showUploadDomainCert, setShowUploadDomainCert] = useState(true);
  const [showUploadCheck, setShowUploadCheck] = useState(false);

  useEffect(() => {
    if (contractFormData.editForm) {
      setParkingLot(contractFormData.hasParking);
      setHasWarehouse(contractFormData.hasWarehouse);
      setShowUploadCheck(true);
      setShowUploadDomainCert(false);
    }
  }, [contractFormData]);

  const savePreview = (data) => {
    setPreview({
      ...previewData,
      ...data,
    });
  };

  return (
    <Card className="mb-4" id={id}>
      <Row className="mb-2">
        <Col span={24}>
          <Title level={3} className="text-purple mb-0">Inmueble</Title>
          <p className="subtitle-text">Ingresa datos del inmueble</p>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} md={24} lg={12}>
          <div className="ant-col ant-form-item-label position-relative d-flex align-items-center">
            <label className="ant-form-item-required mr-1">El inmueble es</label>
          </div>
          <Form.Item
            name="typeOfHousing"
            rules={[{ required: true, message: 'Debes seleccionar una opción' }]}
          >
            <Select size="large" showSearch style={{ width: '100%' }} placeholder="Seleccionar"
              onChange={(value) => { setTypeOfHousing(value); }}
              onSelect={(value) => { savePreview({ typeOfHousing: value }); }}
            >
              {TYPE_OF_HOUSING.map((type, key) => (
                <Option key={key} value={type}>{type}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} md={12} className="position-relative">
          <Form.Item
            label="Dirección"
            name="homeAddress"
            rules={[
              ({
                validator(_, value) {
                  if (value !== undefined && regex.test(value)) {
                    return Promise.reject(
                      'No debe usar simbolos especiales.',
                    );
                  }
                  return Promise.resolve();
                },
              }),
              { required: true, message: 'Debes ingresar una dirección' }
            ]}
            className="mb-1"
          >
            <Input
              size="large"
              className="mb-1"
              autoComplete="off"
              onBlur={(event) => { savePreview({ homeAddress: event.target.value }); }}
              maxLength={100}
            />
          </Form.Item>
          <Text type="secondary" className="small d-block mb-4">Ej: Avenida Libertad 354 Depto 1203</Text>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="homeCommune"
            label="Comuna"
            rules={[{ required: true, message: 'Debes seleccionar una opción' }]}
          >
            <Select size="large" showSearch style={{ width: '100%' }} placeholder="Ingresar o seleccionar"
              onSelect={(value) => { savePreview({ homeCommune: value }); }}
            >
              {REGIONS.map((region, key) => (
                <OptGroup key={key} label={region.region}>
                  {region.comunas.map((comuna, key) => (
                    <Option key={key} value={`${comuna}, ${region.region}`}>{comuna}</Option>
                  ))}
                </OptGroup>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      {typeOfHousing === 'departamento' && (
        <>
          <Row className="mb-4">
            <Col xs={24}>
              <Title level={5} className="mb-2">¿El inmueble cuenta con estacionamiento?</Title>
            </Col>
            <Col>
              <Form.Item className="mb-0" name="hasParking" rules={[{ required: true, message: 'Debes seleccionar una opción' }]}>
                <Radio.Group
                  onChange={(option) => {
                    setParkingLot(option.target.value);
                    previewData.hasParking = option.target.value;
                    savePreview(previewData);
                    if (!option.target.value) {
                      previewData.parking = [];
                      savePreview(previewData);
                    }
                  }}
                >
                  <Radio value={true}>Sí</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          {hasParkingLot && (
            <Form.List name="parking" initialValue={['']}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ name, key }) => (
                    <React.Fragment key={key}>
                      {key > 0 &&
                        <Row>
                          <Col xs={24} md={24}>
                            <Divider orientation="right">
                              <MinusCircleOutlined
                                onClick={() => {
                                  remove(name);
                                  previewData.parking.splice(name, 1);
                                  savePreview(previewData);
                                }}
                              />
                            </Divider>
                          </Col>
                        </Row>
                      }
                      <Row gutter={16}>
                        <Col xs={24} md={12}>
                          <Form.Item
                            label="Ingresa el número de estacionamiento"
                            name={[name, 'number']}
                            rules={[{ required: true, message: 'Debes ingresar un número de estacionamiento' }]}
                          >
                            <InputNumber size="large"
                              onBlur={(event) => {
                                previewData.parking[name] = { number: event.target.value };
                                savePreview(previewData);
                              }}
                              maxLength={5}
                              min={1}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </React.Fragment>
                  ))}
                  <Row>
                    <Col xs={24} md={24}>
                      <Divider orientation="right">
                        <Button className="d-flex align-items-center" type="primary" onClick={() => add()} icon={<PlusOutlined />}>
                          Agregar
                        </Button>
                      </Divider>
                    </Col>
                  </Row>
                </>
              )}
            </Form.List>
          )}
          <Row>
            <Col xs={24}>
              <Title level={5} className="mb-2">¿El inmueble cuenta con bodega?</Title>
            </Col>
            <Col>
              <Form.Item name="hasWarehouse" rules={[{ required: true, message: 'Debes seleccionar una opción' }]}>
                <Radio.Group
                  onChange={(option) => {
                    setHasWarehouse(option.target.value);
                    previewData.hasWarehouse = option.target.value;
                    savePreview(previewData);
                    if (!option.target.value) {
                      previewData.warehouse = [];
                      savePreview(previewData);
                    }
                  }}
                >
                  <Radio value={true}>Sí</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          {hasWarehouse && (
            <Form.List name="warehouse" initialValue={['']}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ name, key }) => (
                    <React.Fragment key={key}>
                      {key > 0 &&
                        <Row>
                          <Col xs={24} md={24}>
                            <Divider orientation="right">
                              <MinusCircleOutlined
                                onClick={() => {
                                  remove(name);
                                  previewData.warehouse.splice(name, 1);
                                  savePreview(previewData);
                                }}
                              />
                            </Divider>
                          </Col>
                        </Row>
                      }
                      <Row gutter={16}>
                        <Col xs={24} md={12}>
                          <Form.Item
                            label="Ingresa el número de bodega"
                            name={[name, 'number']}
                            rules={[{ required: true, message: 'Debes ingresar un número de bodega' }]}
                          >
                            <InputNumber size="large"
                              onBlur={(event) => {
                                previewData.warehouse[name] = { number: event.target.value };
                                savePreview(previewData);
                              }}
                              min={1}
                              maxLength={5}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </React.Fragment>
                  ))}
                  <Row>
                    <Col xs={24} md={24}>
                      <Divider orientation="right">
                        <Button className="d-flex align-items-center" type="primary" onClick={() => add()} icon={<PlusOutlined />}>
                          Agregar
                        </Button>
                      </Divider>
                    </Col>
                  </Row>
                </>
              )}
            </Form.List>
          )}
        </>
      )}
      {showUploadCheck &&
        <Row className="mb-4">
          <Col xs={24}>
            <Checkbox onChange={(value) => { setShowUploadDomainCert(value.target.checked); }}>¿Desea actualizar el certificado de dominio?</Checkbox>
          </Col>
        </Row>
      }
      {showUploadDomainCert &&
      <Row gutter={16}>
        <Col xs={24} md={12} className="position-relative mb-4">
          <Form.Item
            name={'domainCertificate'}
            label={'Adjuntar certificado de dominio vigente de propiedad (Máximo 90 días de antigüedad)'}
            rules={[
              ({
                validator(_, value) {
                  if (value && value.fileList && value.fileList[0]) {
                    if (value.file.size > 4000000) {
                      return Promise.reject(
                        'El PDF excede tamaño máximo de 4MB.',
                      );
                    }
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    'Debe cargar el certificado en formato PDF',
                  );
                },
                required: true,
              })
            ]}
            className="position-relative"
          >
            <Upload
              accept='application/pdf'
              customRequest={({ onSuccess }) => { setTimeout(() => { onSuccess('ok'); }, 0); }}
              multiple={false}
              maxCount={1}
            >
              <Button icon={<UploadOutlined />}>Subir archivo</Button>
            </Upload>
          </Form.Item>
          <Text type="secondary" className="small d-block">El PDF no debe ser mayor a 4MB</Text>
        </Col>

        <Col xs={24} md={12}>
          <Title level={3} className="text-black mb-0">¿Dudas sobre este documento?</Title>
          <Row className="mb-2 text-center">
            <Link href="https://www.legalchile.cl/contrato-de-arriendo/faqs" target="_blank" >
              <p>Revisa nuestras preguntas frecuentes</p>
            </Link>
          </Row>
        </Col>
      </Row>
      }
    </Card>
  );
};

PropertyForm.propTypes = {
  id: PropTypes.string.isRequired,
  contractFormData: PropTypes.object.isRequired,
  form: PropTypes.object,
  previewData: PropTypes.object.isRequired,
  setPreview: PropTypes.func.isRequired,
  regex: PropTypes.regex,
};

const data = (state) => ({
  contractFormData: state.contract.contractFormData,
  previewData: state.contract.previewData,
  regex: state.forms.regex,
});

const actions = (dispatch) => ({
  setPreview: (data) => dispatch({ type: SET_PREVIEW_DATA, payload: { ...data } }),
});

export default connect(data, actions)(PropertyForm);